import * as jsxRuntime from "/Users/sophial/Code/Work/Centrifuge/apps/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment